import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_w3gw1va",
        "template_ta8hxrp",
        form.current,
        "L1JLjb4PpIPrIKEpu"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    alert("Message send successfully!");
  };
  return (
    <section className="mt-24 font-medium" id="contact">
      <h2 className="text-cyan-300 text-2xl font-medium text-center mb-12">
        Contact Me
      </h2>
      <div className="grid md:grid-cols-[300px,1fr] grid-cols-1 xl:gap-48 lg:gap-32 gap-8 text-gray-300">
        <div className="flex flex-col gap-4">
          <article className="border border-cyan-500 rounded-xl p-5 text-center transition bg-black bg-opacity-20 hover:bg-opacity-40">
            <h4>Email</h4>
            <h5>toukir.ahammed36@gmail.com</h5>
            <a
              className="text-cyan-600"
              href="mailto:toukir.ahammed36@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              Send an email
            </a>
          </article>

          <article className="border border-cyan-500 rounded-xl p-5 text-center transition bg-black bg-opacity-20 hover:bg-opacity-40">
            <h4>Messenger</h4>
            <h5>Toukir Ahammed</h5>
            <a
              className="text-cyan-600"
              href="https://m.me/toukir.ahammed36"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </article>

          <article className="border border-cyan-500 rounded-xl p-5 text-center transition bg-black bg-opacity-20 hover:bg-opacity-40">
            <h4>WhatsApp</h4>
            <h5>+8801671918124</h5>
            <a
              className="text-cyan-600"
              href="https://api.whatsapp.com/send?phone=+8801671918124"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </article>
        </div>
        <div>
          <form ref={form} onSubmit={sendEmail} className="flex flex-col gap-4">
            <input
              className="p-2 rounded-lg border border-cyan-500 bg-black bg-opacity-20 placeholder:opacity-50 placeholder:font-normal placeholder:text-sm hover:bg-opacity-40 transition"
              type="text"
              name="name"
              placeholder="Your Full Name"
              required
            />
            <input
              className="p-2 rounded-lg border border-cyan-500 bg-black bg-opacity-20 placeholder:opacity-50 placeholder:font-normal placeholder:text-sm hover:bg-opacity-40 transition"
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <textarea
              className="p-2 rounded-lg border border-cyan-500 bg-black bg-opacity-20 placeholder:opacity-50 placeholder:font-normal placeholder:text-sm hover:bg-opacity-40 transition"
              name="message"
              rows="7"
              placeholder="Your Message"
              required
            ></textarea>
            <button
              type="submit"
              className="border border-cyan-300 py-2 px-5 rounded-lg bg-cyan-300 text-gray-800 hover:bg-cyan-500 w-48 mx-auto"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
